export default "__VITE_ASSET__DzFqIhfI__"